import React, { Component, Fragment } from 'react';
import {
  Container,
  Row, Col, Input, Button, Form, FormGroup
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTimes, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import MarketingTextarea from './Marketing2Textarea';
import ConfirmButton from '../Modal/ConfirmButton';
class MarketingCalls extends Component {

  standardRow = (call) => {
    return (
      <Row className="adminRow pointer text-left" onClick={() => this.props.onEdit(call.ID)}>
        <Col md={4}>{call.Name}</Col>
        <Col md={8}>{call.Type}</Col>
      </Row>
    )
  }

  editRow = (call) => {
    return (
      <Row className="editRow adminRow">
        <Col md={8} className="text-left">
          <Form inline>
            <FormGroup className="mr-2">
              <Input
                placeholder="Name"
                name="name"
                value={this.props.editCall.name + ''}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
            <FormGroup className="mr-2">
              <Input
                type="select"
                name="callTypeID"
                value={this.props.editCall.callTypeID}
                onChange={e => this.props.onChange(e, 'edit')}>
                <option value={0}>Type</option>
                {this.props.types.map(type => (
                  <option key={type.TypeID} value={type.TypeID}>{type.Type}</option>
                ))}
              </Input>
            </FormGroup>
          </Form>
          <MarketingTextarea
            value={this.props.editCall.script}
            placeholder="Script"
            name="script"
            onChange={this.props.onChange}
            edit={true}
          />
        </Col>
        <Col md={4} className="text-right">
          <Button className="mx-1" color="success" onClick={this.props.handleEdit} title="Edit Call">
            <FontAwesomeIcon icon={faCheck} />
          </Button>
          <ConfirmButton className="mx-3" color="danger" onClick={() => this.props.onDelete(call.ID)} edit="Delete Call">
            <FontAwesomeIcon icon={faTrashAlt} />
          </ConfirmButton>
          <Button className="mx-1" color="secondary" onClick={this.props.handleCancel} title="Cancel">
            <FontAwesomeIcon icon={faTimes} />
          </Button>
        </Col>
      </Row>
    )
  }

  addRow = () => {
    return (<Row className="py-4 text-left align-items-bottom">
      <Col md={8}>
        <Form inline>
          <FormGroup className="mr-2">
            Add New Call
          </FormGroup>
          <FormGroup className="mr-2">
            <Input
              placeholder="Call Template Name"
              name="name"
              value={this.props.newCall.name + ''}
              onChange={e => this.props.onChange(e)} />
          </FormGroup>
          <FormGroup className="mr-2">
            <Input
              type="select"
              name="callTypeID"
              value={this.props.newCall.callTypeID}
              onChange={e => this.props.onChange(e)}>
              <option value={0}>Type</option>
              {this.props.types.map(type => (
                <option key={type.TypeID} value={type.TypeID}>{type.Type}</option>
              ))}
            </Input>
          </FormGroup>
        </Form>
        <MarketingTextarea
          value={this.props.newCall.script}
          placeholder="Script"
          name="script"
          onChange={this.props.onChange}
          edit={false}
        />
      </Col>
      <Col md={4} className="text-right">
        <Button
          disabled={this.props.newCall.name === '' || this.props.newCall.script === '' || parseInt(this.props.newCall.callTypeID) === 0}
          color="primary"
          onClick={this.props.handleAdd}>
          Add Call
        </Button>
      </Col>
    </Row>
    )
  }

  render() {
    return (
      <Container className="adminContainer" fluid>
        {this.props.calls.map(call => (
          <Fragment key={call.ID}>{this.props.editCall.callID === call.ID ? this.editRow(call) : this.standardRow(call)}</Fragment>
        ))}
        {this.addRow()}
      </Container>
    );
  }
}

export default MarketingCalls;